import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  contentType() {
    const options = ['product', 'productshop', 'custom'];

    return faker.helpers.arrayElement(options);
  },

  internalRemarks() {
    return faker.lorem.paragraph();
  },

  productTargetType() {
    if (this.contentType === 'product') {
      const productOptions = ['amazon_physical', 'itunes', 'apple'];

      return faker.helpers.arrayElement(productOptions);
    }

    if (this.contentType === 'productshop') {
      const productshopOptions = ['Weltbild', 'HVV', 'YouTube'];

      return faker.helpers.arrayElement(productshopOptions);
    }

    return null;
  },

  urlHash() {
    return faker.random.alphaNumeric(5);
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
